// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 838 ? "bootloader" : chunkId) + "." + {"206":"6fe81137","377":"c0a6fc68","607":"3535629d","838":"749cca5c"}[chunkId] + ".css";
};